import type { FC } from 'react';
import React from 'react';

import { IconText } from '@motorway/mw-highway-code';

import type { AccountSidebarTitleProps } from '../AccountSidebar.types';

import styles from './AccountSidebarTitle.module.scss';

const AccountSidebarTitle: FC<AccountSidebarTitleProps> = ({ icon, title }) => (
	<div className={styles.accountSidebarTitle}>
		<IconText icon={icon} text={title} variant="small--heading5" />
	</div>
);

export default AccountSidebarTitle;
